import styled from 'styled-components';
import { Picture } from 'common/components/Picture';

export const BackgroundImage = styled(Picture)`
  top: 0;
  left: 0;
  display: flex;
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: absolute;
  object-fit: cover;
`;
